import {
  SigIdCalculationRead,
  SigIdPayerServiceListItem,
  SigIdPaymentRead
} from '../../services/sig-id.common.model';
import { createReducer, on } from '@ngrx/store';
import {
  loadCalculation,
  loadCalculationFailure,
  loadCalculationSuccess,
  loadPayerServices,
  loadPayerServicesFailure,
  loadPayerServicesSuccess,
  loadPayment,
  loadPaymentFailure,
  loadPaymentSuccess
} from '../actions/my-bills.actions';

export interface MyBillsState {
  services: SigIdPayerServiceListItem[];
  payment: SigIdPaymentRead | null;
  loading: number;
  pending: number;
  calculation: SigIdCalculationRead | null;
}

export const initialMyBillsState: MyBillsState = {
  loading: 0,
  pending: 0,
  services: [],
  payment: null,
  calculation: null
};

export const myBillsReducer = createReducer(
  initialMyBillsState,
  on(loadPayerServices, state => ({ ...state, loading: state.loading + 1 })),
  on(loadPayerServicesSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    services: action.services
  })),
  on(loadPayerServicesFailure, state => ({ ...state, loading: state.loading - 1 })),

  on(loadPayment, state => ({ ...state, loading: state.loading + 1 })),
  on(loadPaymentSuccess, (state, action) => ({ ...state, loading: state.loading - 1, payment: action.payment })),
  on(loadPaymentFailure, state => ({ ...state, loading: state.loading - 1 })),

  on(loadCalculation, state => ({ ...state, loading: state.loading + 1 })),
  on(loadCalculationSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    calculation: action.calculation
  })),
  on(loadCalculationFailure, state => ({ ...state, loading: state.loading - 1 }))
);
